<ion-app>
  <!-- Indicador de estado de red -->
  <div class="network-indicator" *ngIf="!isOnline"></div>

  <!-- Split Pane: menú visible en pantallas grandes (≥992px) -->
  <!-- Se puede deshabilitar para colapsar el menú -->
  <!-- No usar [disabled] en main-menu: provoca carrera con MenuController.enable() al salir de
       /login|/callback hacia /inicio (el enable(true) síncrono falla mientras el DOM aún tiene
       disabled; el split-pane no recupera el lateral). Visibilidad solo vía MenuController. -->
  <ion-split-pane contentId="main-content" [when]="splitPaneDisabled ? false : 'lg'">
    <ion-menu side="start" menuId="main-menu" contentId="main-content">
      <ion-header>
        <ion-toolbar color="primary" class="menu-toolbar">
          <div class="menu-logo-container">
            <span class="menu-logo-text">Plataforma Programa SAT</span>
          </div>
        </ion-toolbar>
      </ion-header>
      <ion-content>
        <!-- Información del usuario en la parte superior -->
        <div class="menu-header" *ngIf="mostrarShellAutenticado && usuarioActual" [class.menu-header-collapsed]="gestionExpandido">
          <div class="avatar-menu-btn">
            <ion-avatar class="avatar-menu">
              <span class="avatar-iniciales">{{ getIniciales(usuarioActual.nombre) }}</span>
            </ion-avatar>
          </div>
          <h2>{{ usuarioActual.nombre }}</h2>
          <p>{{ usuarioActual.email }}</p>
        </div>

        <!-- Menú online: todas las secciones excepto Ruta del día -->
        <ion-list lines="none" *ngIf="isOnline">
          <ion-menu-toggle menu="main-menu" auto-hide="false">
            <ion-item button routerLink="/inicio" routerDirection="root" routerLinkActive="menu-item-active">
              <ion-icon name="grid-outline" slot="start"></ion-icon>
              <ion-label>Inicio</ion-label>
            </ion-item>
          </ion-menu-toggle>

          <ion-menu-toggle menu="main-menu" auto-hide="false">
            <ion-item button routerLink="/visitas" routerDirection="root" routerLinkActive="menu-item-active">
              <ion-icon name="calendar-number-outline" slot="start"></ion-icon>
              <ion-label>Visitas</ion-label>
            </ion-item>
          </ion-menu-toggle>

          <ion-menu-toggle menu="main-menu" auto-hide="false">
            <ion-item button routerLink="/actividades-grupales" routerDirection="root"
              routerLinkActive="menu-item-active">
              <ion-icon name="people-outline" slot="start"></ion-icon>
              <ion-label>Actividades Grupales</ion-label>
            </ion-item>
          </ion-menu-toggle>


          <!-- Ítem principal Gestión:
               Si hay productor activo → alterna el sub-menú (sin navegar ni cerrar el menú).
               Si no hay productor → navega a /gestion y cierra el menú. -->
          <ion-item button (click)="toggleGestion()" class="menu-category-item"
            [class.menu-item-active]="esRutaGestion">
            <ion-icon [name]="gestionExpandido ? 'briefcase-sharp' : 'briefcase-outline'" slot="start"></ion-icon>
            <ion-label>Gestión</ion-label>
            <ion-icon *ngIf="productorActivoParaMenu"
              [name]="gestionExpandido ? 'chevron-up-outline' : 'chevron-down-outline'"
              slot="end"></ion-icon>
          </ion-item>

          <!-- Sub-menú de Gestión: solo visible cuando hay productor activo -->
          <ion-list *ngIf="gestionExpandido && productorActivoParaMenu" lines="none" class="menu-sublist">
            <!-- FICHA DE USUARIO INDAP -->
            <div class="menu-sublist-categoria">FICHA DE USUARIO INDAP</div>
            <ion-menu-toggle menu="main-menu" auto-hide="false">
              <ion-item button
                [routerLink]="['/gestion/acciones', productorActivoParaMenu.id_productor, 'caracterizacion']"
                routerDirection="root" routerLinkActive="menu-item-active" class="menu-subitem">
                <ion-icon name="person-outline" slot="start"></ion-icon>
                <ion-label>Caracterización</ion-label>
              </ion-item>
            </ion-menu-toggle>
            <ion-menu-toggle menu="main-menu" auto-hide="false">
              <ion-item button
                [routerLink]="['/gestion/acciones', productorActivoParaMenu.id_productor, 'margen-bruto']"
                routerDirection="root" routerLinkActive="menu-item-active" class="menu-subitem">
                <ion-icon name="trending-up-outline" slot="start"></ion-icon>
                <ion-label>Margen Bruto</ion-label>
              </ion-item>
            </ion-menu-toggle>

            <!-- PLAN DE NEGOCIO -->
            <div class="menu-sublist-categoria">PLAN DE NEGOCIO</div>
            <ion-menu-toggle menu="main-menu" auto-hide="false">
              <ion-item button
                [routerLink]="['/gestion/acciones', productorActivoParaMenu.id_productor, 'diagnostico']"
                routerDirection="root" routerLinkActive="menu-item-active" class="menu-subitem">
                <ion-icon name="document-text-outline" slot="start"></ion-icon>
                <ion-label>Diagnóstico</ion-label>
              </ion-item>
            </ion-menu-toggle>
            <ion-menu-toggle menu="main-menu" auto-hide="false">
              <ion-item button
                [routerLink]="['/gestion/acciones', productorActivoParaMenu.id_productor, 'soluciones']"
                routerDirection="root" routerLinkActive="menu-item-active" class="menu-subitem">
                <ion-icon name="bulb-outline" slot="start"></ion-icon>
                <ion-label>Soluciones</ion-label>
              </ion-item>
            </ion-menu-toggle>
            <ion-menu-toggle menu="main-menu" auto-hide="false">
              <ion-item button
                [routerLink]="['/gestion/acciones', productorActivoParaMenu.id_productor, 'plan-trabajo']"
                routerDirection="root" routerLinkActive="menu-item-active" class="menu-subitem">
                <ion-icon name="calendar-outline" slot="start"></ion-icon>
                <ion-label>Plan de Trabajo</ion-label>
              </ion-item>
            </ion-menu-toggle>
            <ion-menu-toggle menu="main-menu" auto-hide="false">
              <ion-item button
                [routerLink]="['/gestion/acciones', productorActivoParaMenu.id_productor, 'plan-inversion']"
                routerDirection="root" routerLinkActive="menu-item-active" class="menu-subitem">
                <ion-icon name="wallet-outline" slot="start"></ion-icon>
                <ion-label>Plan de Inversión</ion-label>
              </ion-item>
            </ion-menu-toggle>


            <!-- SEGUIMIENTO -->
            <div class="menu-sublist-categoria">SEGUIMIENTO</div>
            <ion-menu-toggle menu="main-menu" auto-hide="false">
              <ion-item button
                [routerLink]="['/gestion/acciones', productorActivoParaMenu.id_productor, 'historial-visitas']"
                routerDirection="root" routerLinkActive="menu-item-active" class="menu-subitem">
                <ion-icon name="calendar-number-outline" slot="start"></ion-icon>
                <ion-label>Historial de Visitas</ion-label>
              </ion-item>
            </ion-menu-toggle>
            <ion-menu-toggle menu="main-menu" auto-hide="false">
              <ion-item button
                [routerLink]="['/gestion/acciones', productorActivoParaMenu.id_productor, 'seguimiento-inversion']"
                routerDirection="root" routerLinkActive="menu-item-active" class="menu-subitem">
                <ion-icon name="analytics-outline" slot="start"></ion-icon>
                <ion-label>Seguimiento Inversión</ion-label>
              </ion-item>
            </ion-menu-toggle>
            <ion-menu-toggle *ngIf="false" menu="main-menu" auto-hide="false">
              <ion-item button
                [routerLink]="['/gestion/acciones', productorActivoParaMenu?.id_productor, 'supervision-grupal']"
                routerDirection="root" routerLinkActive="menu-item-active" class="menu-subitem">
                <ion-icon name="clipboard-outline" slot="start"></ion-icon>
                <ion-label>Supervisión Grupal</ion-label>
              </ion-item>
            </ion-menu-toggle>
            <ion-menu-toggle *ngIf="false" menu="main-menu" auto-hide="false">
              <ion-item button
                [routerLink]="['/gestion/acciones', productorActivoParaMenu?.id_productor, 'supervision-individual']"
                routerDirection="root" routerLinkActive="menu-item-active" class="menu-subitem">
                <ion-icon name="clipboard-outline" slot="start"></ion-icon>
                <ion-label>Supervisión Individual</ion-label>
              </ion-item>
            </ion-menu-toggle>

            <ion-menu-toggle menu="main-menu" auto-hide="false">
              <ion-item button
                [routerLink]="['/gestion/acciones', productorActivoParaMenu.id_productor, 'encuesta-evaluacion']"
                routerDirection="root" routerLinkActive="menu-item-active" class="menu-subitem">
                <ion-icon name="star-outline" slot="start"></ion-icon>
                <ion-label>Encuesta de Evaluación</ion-label>
              </ion-item>
            </ion-menu-toggle>
            <ion-menu-toggle *ngIf="mostrarMenuCopago()" menu="main-menu" auto-hide="false">
              <ion-item button
                [routerLink]="['/gestion/acciones', productorActivoParaMenu.id_productor, 'copago']"
                routerDirection="root" routerLinkActive="menu-item-active" class="menu-subitem">
                <ion-icon name="checkbox-outline" slot="start"></ion-icon>
                <ion-label>Copago</ion-label>
              </ion-item>
            </ion-menu-toggle>
          </ion-list>


          <ion-menu-toggle menu="main-menu" auto-hide="false">
            <ion-item button routerLink="/analisis" routerDirection="root" routerLinkActive="menu-item-active">
              <ion-icon name="bar-chart-outline" slot="start"></ion-icon>
              <ion-label>Análisis</ion-label>
            </ion-item>
          </ion-menu-toggle>

          <ion-menu-toggle menu="main-menu" auto-hide="false">
            <ion-item button routerLink="/reportes" routerDirection="root" routerLinkActive="menu-item-active">
              <ion-icon name="reader-outline" slot="start"></ion-icon>
              <ion-label>Reportes</ion-label>
            </ion-item>
          </ion-menu-toggle>

          <ion-menu-toggle menu="main-menu" auto-hide="false">
            <ion-item button routerLink="/ayuda" routerDirection="root" routerLinkActive="menu-item-active">
              <ion-icon name="help-circle-outline" slot="start"></ion-icon>
              <ion-label>Ayuda</ion-label>
            </ion-item>
          </ion-menu-toggle>

          <ion-menu-toggle menu="main-menu" auto-hide="false" *ngIf="false">
            <ion-item button routerLink="/fichas" routerDirection="root" routerLinkActive="menu-item-active">
              <ion-icon name="document-outline" slot="start"></ion-icon>
              <ion-label>Fichas</ion-label>
            </ion-item>
          </ion-menu-toggle>

        </ion-list>

        <!-- Sin conexión: Ruta del día y Configuración (restablecer simulación offline) -->
        <ion-list lines="none" *ngIf="!isOnline">
          <ion-menu-toggle menu="main-menu" auto-hide="false">
            <ion-item button (click)="navegarARutaDelDia()" [class.menu-item-active]="menuRutaDelDiaActiva">
              <ion-icon name="map-outline" slot="start"></ion-icon>
              <ion-label>Ruta del día</ion-label>
            </ion-item>
            <ion-item button routerLink="/configuracion" routerDirection="root" [class.menu-item-active]="menuConfiguracionActiva">
              <ion-icon name="settings-outline" slot="start"></ion-icon>
              <ion-label>Configuración</ion-label>
            </ion-item>
          </ion-menu-toggle>
        </ion-list>
      </ion-content>
    </ion-menu>

    <!-- Contenido principal -->
    <div class="ion-page" id="main-content">
      <!-- Header Global -->
      <ion-header *ngIf="mostrarShellAutenticado && usuarioActual" class="global-header">
        <ion-toolbar>
          <ion-buttons slot="start">
            <!-- Botón único de menú:
                 - En móvil: siempre abre el menú overlay (ion-menu-button estándar)
                 - En desktop con menú expandido: colapsa el menú
                 - En desktop con menú colapsado: expande el menú -->
            <ion-button (click)="onMenuButtonClick()" class="menu-toggle-btn" aria-label="Abrir menú">
              <ion-icon slot="icon-only" name="menu-outline"></ion-icon>
            </ion-button>
          </ion-buttons>
          <ion-title></ion-title>
          <ion-buttons slot="end">
            <ng-container *ngIf="isOnline">
            <!-- Selector de Perfil (cuando hay más de uno) -->
            <div class="perfil-selector" *ngIf="usuarioActual.perfiles && usuarioActual.perfiles.length > 1">
              <ion-select [value]="perfilActivo?.id_perfil" (ionChange)="onPerfilChange($event)" interface="popover"
                class="perfil-select" placeholder="Seleccionar perfil"
                [interfaceOptions]="{ cssClass: 'select-popover select-popover-medium' }">
                <ion-select-option *ngFor="let perfil of usuarioActual.perfiles" [value]="perfil.id_perfil">
                  {{ perfil.descripcion }}
                </ion-select-option>
              </ion-select>
            </div>
            <!-- Mostrar perfil único si solo hay uno -->
            <ion-chip *ngIf="usuarioActual.perfiles && usuarioActual.perfiles.length === 1" class="perfil-chip">
              <ion-icon name="person-outline"></ion-icon>
              <ion-label>{{ usuarioActual.perfiles[0].descripcion }}</ion-label>
            </ion-chip>

            <!-- Región → Área → UO (orden según docs/HEADER_SELECTORES.md) -->
            <div class="area-selector" *ngIf="reglasHeader.mostrarSelectorRegion && regiones.length > 1">
              <ion-select [value]="idRegionSeleccionada" (ionChange)="onRegionChange($event)" interface="popover"
                class="area-select" placeholder="Región"
                [interfaceOptions]="{ cssClass: 'select-popover select-popover-medium' }">
                <ion-select-option *ngFor="let region of regiones" [value]="region.id">
                  {{ region.nombre }}
                </ion-select-option>
              </ion-select>
            </div>
            <ion-chip *ngIf="reglasHeader.mostrarSelectorRegion && regiones.length === 1" class="area-chip">
              <ion-icon name="globe-outline"></ion-icon>
              <ion-label>{{ regiones[0]?.nombre }}</ion-label>
            </ion-chip>

            <div class="area-selector" *ngIf="reglasHeader.mostrarSelectorArea && areas.length > 1">
              <ion-select [value]="idAreaSeleccionada" (ionChange)="onAreaChange($event)" interface="popover"
                class="area-select" placeholder="Área"
                [interfaceOptions]="{ cssClass: 'select-popover select-popover-medium' }">
                <ion-select-option *ngFor="let area of areas" [value]="area.id">
                  {{ area.nombre }}
                </ion-select-option>
              </ion-select>
            </div>
            <ion-chip *ngIf="reglasHeader.mostrarSelectorArea && areas.length === 1" class="area-chip">
              <ion-icon name="map-outline"></ion-icon>
              <ion-label>{{ areas[0]?.nombre }}</ion-label>
            </ion-chip>

            <!-- Selector de Unidad Operativa: solo cuando hay más de una opción -->
            <div class="unidad-operativa-selector" *ngIf="reglasHeader.mostrarSelectorUO && unidadesOperativas.length > 1">
              <ion-select [value]="unidadOperativaActiva" (ionChange)="onUnidadOperativaChange($event)"
                interface="popover" class="unidad-operativa-select" placeholder="Unidad Operativa"
                [interfaceOptions]="{ cssClass: 'select-popover select-popover-wide unidad-operativa-popover' }">
                <ion-select-option *ngFor="let unidad of unidadesOperativas" [value]="unidad.id">
                  {{ unidad.nombre }}
                </ion-select-option>
              </ion-select>
            </div>
            <!-- Chip cuando hay una sola UO (igual que con Áreas) -->
            <ion-chip *ngIf="reglasHeader.mostrarSelectorUO && unidadesOperativas.length === 1" class="unidad-operativa-chip">
              <ion-icon name="business-outline"></ion-icon>
              <ion-label>{{ unidadesOperativas[0]?.nombre }}</ion-label>
            </ion-chip>
            </ng-container>

            <!-- Notificaciones solicitudes 48h (solo Extensionista, online) -->
            <ng-container *ngIf="isOnline && esExtensionista">
              <ion-button fill="clear" id="notificaciones-menu-trigger" class="notificaciones-header-btn"
                aria-label="Notificaciones de solicitudes últimas 48 horas">
                <ion-icon name="notifications-outline" slot="icon-only"></ion-icon>
                <ion-badge *ngIf="notificacionesUltimas48hCount > 0" color="danger" class="notificaciones-header-badge">
                  {{ etiquetaBadgeNotificaciones48h }}
                </ion-badge>
              </ion-button>
              <ion-popover trigger="notificaciones-menu-trigger" triggerAction="click" [dismissOnSelect]="false"
                reference="event" side="bottom" alignment="end" cssClass="popover-notificaciones-48h"
                (willPresent)="onNotificacionesPopoverWillPresent()">
                <ng-template>
                  <ion-content class="popover-notificaciones-48h-content">
                    <ion-list lines="full">
                      <ion-list-header *ngIf="notificacionesUltimas48hItems.length > 0" class="notif-48h-list-header">
                        <ion-label>Notificaciones de las últimas 48 horas</ion-label>
                      </ion-list-header>
                      <ion-item *ngIf="notificacionesUltimas48hItems.length === 0" lines="none">
                        <ion-label class="ion-text-wrap">No hay solicitudes en las últimas 48 horas.</ion-label>
                      </ion-item>
                      <ion-item *ngFor="let n of notificacionesUltimas48hItems" lines="none" class="item-notif-48h">
                        <ion-label class="ion-text-wrap">
                          <div class="notif-48h-fila-principal">
                            <span class="notif-48h-punto-slot" aria-hidden="true">
                              <span *ngIf="notificacionesEstadoIndicadorClase(n) as puntoClase" class="notif-48h-punto"
                                [ngClass]="puntoClase"></span>
                            </span>
                            <div class="notif-48h-textos">
                              <p class="notif-48h-titulo">{{ notificacionesTextoPrincipal(n) }}</p>
                              <p *ngIf="notificacionesRelativaDesdeRespuesta(n) as rel" class="notif-48h-fecha">{{ rel }}</p>
                            </div>
                          </div>
                        </ion-label>
                      </ion-item>
                    </ion-list>
                  </ion-content>
                </ng-template>
              </ion-popover>
            </ng-container>

            <!-- Avatar con menú de usuario -->
            <ion-button fill="clear" id="avatar-menu-trigger" class="avatar-button">
              <ion-avatar class="header-avatar">
                <span class="avatar-iniciales">{{ getIniciales(usuarioActual.nombre) }}</span>
              </ion-avatar>
            </ion-button>

            <!-- Popover del menú de usuario (reference="event" para alineación correcta en iOS/iPad) -->
            <ion-popover trigger="avatar-menu-trigger" triggerAction="click" [dismissOnSelect]="true" reference="event"
              side="bottom" alignment="start">
              <ng-template>
                <ion-content>
                  <ion-list lines="none">
                    <ion-item button routerLink="/perfil" routerDirection="root">
                      <ion-icon name="person-outline" slot="start"></ion-icon>
                      <ion-label>Perfil</ion-label>
                    </ion-item>
                    <ion-item button routerLink="/terminos-de-uso" routerDirection="root">
                      <ion-icon name="document-text-outline" slot="start"></ion-icon>
                      <ion-label>Términos y Condiciones</ion-label>
                    </ion-item>
                    <ion-item button routerLink="/politica-de-privacidad" routerDirection="root">
                      <ion-icon name="shield-checkmark-outline" slot="start"></ion-icon>
                      <ion-label>Política de Privacidad</ion-label>
                    </ion-item>
                    <ion-item button routerLink="/configuracion" routerDirection="root">
                      <ion-icon name="settings-outline" slot="start"></ion-icon>
                      <ion-label>Configuración</ion-label>
                    </ion-item>
                    <ion-item button (click)="cerrarSesion()" class="logout-item">
                      <ion-icon name="log-out-outline" slot="start" color="danger"></ion-icon>
                      <ion-label color="danger">Cerrar Sesión</ion-label>
                    </ion-item>
                  </ion-list>
                </ion-content>
              </ng-template>
            </ion-popover>
          </ion-buttons>
        </ion-toolbar>
      </ion-header>

      <ion-router-outlet [class.con-header-global]="mostrarShellAutenticado"></ion-router-outlet>
    </div>
  </ion-split-pane>

  <!-- Panel de visitas: fuera del split-pane para que actúe como overlay sobre todo el contenido -->
  <ion-menu side="end" type="overlay" [menuId]="panelService.menuId" contentId="main-content"
    [disabled]="panelService.getAccion() === null" (ionDidClose)="panelService.alCerrarMenu()"
    class="visita-panel-menu">
    <ion-content *ngIf="panelService.getAccion() !== null">
      <app-formulario-resumen-firmado-visita
        *ngIf="panelService.getAccion() === 'subir-resumen-firmado'"
        [dentroDeMenu]="true" [visible]="true"
        [visita]="panelService.getVisita()"
        (visibleChange)="panelService.onVisibleChange($event)"
        (guardado)="panelService.onGuardado()">
      </app-formulario-resumen-firmado-visita>
      <app-formulario-visita
        *ngIf="panelService.getAccion() !== 'subir-resumen-firmado'"
        [dentroDeMenu]="true" [accion]="panelService.getAccion()!"
        [visita]="panelService.getVisita() || undefined" [visible]="true"
        [permitirPdf]="panelService.getPermitirPdf()"
        (visibleChange)="panelService.onVisibleChange($event)" (guardado)="panelService.onGuardado()">
      </app-formulario-visita>
    </ion-content>
  </ion-menu>

  <!-- Panel de agendamiento offline: no usar [disabled] ligado al flag (carrera con MenuController.open()). -->
  <ion-menu side="end" type="overlay" swipeGesture="false" [menuId]="offlinePanelService.menuId" contentId="main-content"
    (ionDidClose)="offlinePanelService.alCerrarMenu()" class="visita-panel-menu">
    <ion-content *ngIf="offlinePanelService.getAbierto()">
      <app-formulario-visita-offline
        [visible]="true"
        (visibleChange)="offlinePanelService.onVisibleChange($event)"
        (guardado)="offlinePanelService.onGuardado()">
      </app-formulario-visita-offline>
    </ion-content>
  </ion-menu>

  <!-- Panel de acciones Hoja de Ruta: mismo patrón overlay que Agendar.
       No usar [disabled] ligado al contexto: provoca carreras con MenuController.open() tras cerrar el popover
       (open falla hasta el siguiente ciclo de detección de cambios). El contenido se controla con *ngIf. -->
  <ion-menu side="end" type="overlay" swipeGesture="false" [menuId]="rutaAccionPanelService.menuId"
    contentId="main-content" (ionDidClose)="rutaAccionPanelService.alCerrarMenu()" class="visita-panel-menu">
    <ion-content class="panel-hoja-ruta-ion-fill" *ngIf="rutaAccionPanelService.getContexto() as ctx">
      <app-panel-accion-hoja-ruta
        [visible]="true"
        [contexto]="ctx"
        (visibleChange)="rutaAccionPanelService.onVisibleChange($event)"
        (guardado)="rutaAccionPanelService.onGuardado()">
      </app-panel-accion-hoja-ruta>
    </ion-content>
  </ion-menu>

  <!-- Panel de actividades grupales: igual patrón que Agendar (lateral derecho) -->
  <ion-menu side="end" type="overlay" [menuId]="actividadGrupalPanelService.menuId" contentId="main-content"
    [disabled]="!actividadGrupalPanelService.getAbierto()" (ionDidClose)="actividadGrupalPanelService.alCerrarMenu()"
    class="actividad-grupal-panel-menu">
    <ion-content *ngIf="actividadGrupalPanelService.getAbierto()">
      <app-detalle-actividad-grupal
        *ngIf="actividadGrupalPanelService.getModo() === 'ver_detalle'"
        [actividad]="actividadGrupalPanelService.getActividad()"
        (visibleChange)="actividadGrupalPanelService.onVisibleChange($event)">
      </app-detalle-actividad-grupal>
      <app-formulario-asistencia-actividad-grupal
        *ngIf="actividadGrupalPanelService.getModo() === 'subir_asistencia'"
        [dentroDeMenu]="true" [visible]="true"
        [actividad]="actividadGrupalPanelService.getActividad()"
        (visibleChange)="actividadGrupalPanelService.onVisibleChange($event)"
        (guardado)="actividadGrupalPanelService.onGuardado()">
      </app-formulario-asistencia-actividad-grupal>
      <app-formulario-actividad-grupal
        *ngIf="actividadGrupalPanelService.getModo() === 'crear' || actividadGrupalPanelService.getModo() === 'editar'"
        [dentroDeMenu]="true" [visible]="true"
        [accion]="actividadGrupalPanelService.getAccion()!"
        [actividad]="actividadGrupalPanelService.getActividad()"
        (visibleChange)="actividadGrupalPanelService.onVisibleChange($event)" (guardado)="actividadGrupalPanelService.onGuardado()">
      </app-formulario-actividad-grupal>
    </ion-content>
  </ion-menu>

</ion-app>